/* Which purchases the unified checkout made, so its receipt can answer on the
   confirmation URL it shares with the other two arms.

   The alternative was reading the unified gate at the route, and that cannot be
   done synchronously — checkGate falls back until Statsig settles, so the shared
   receipt mounted first and was swapped a moment later. This is a note the
   checkout leaves for itself: available on the first render, no gate involved.

   A handful of ids rather than all of them: it exists for the reload, the back
   button and the bookmark, all of which are the order just placed. An older
   purchase falls off and its URL answers with the shared receipt, which is what
   it did before this page existed. */
const KEY = 'bump-unifiedReceipts';
const KEEP = 5;

const read = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(stored) ? stored.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

export const rememberUnifiedReceipt = (purchaseId) => {
  if (!purchaseId) return;
  try {
    const next = [purchaseId, ...read().filter((id) => id !== purchaseId)];
    localStorage.setItem(KEY, JSON.stringify(next.slice(0, KEEP)));
  } catch {
    // A shopper with storage refused still gets the receipt they were pushed
    // to; only the reload falls back to the shared page.
  }
};

export const isUnifiedReceipt = (purchaseId) =>
  !!purchaseId && read().includes(purchaseId);

export default { rememberUnifiedReceipt, isUnifiedReceipt };
